import React, { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import useAxios from "axios-hooks";
import { Spinner, Toggle } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import CreditReportActiveUserThresholdingTable from './CreditReportActiveUserThresholdingTable';

const CreditReportActiveUserThresholdingList = () => {
    const history = useHistory();
    const [selectedThresholdId, setSelectedThresholdId] = useState();
    let { url } = useRouteMatch();

    const [{ data: thresholds, loading, error }, refetch] = useAxios("credit-reports/thresholding", { method: "get" });

    if (loading)
        return <Spinner className="absolute-center" label="Loading Thresholds..." />;

    if (!loading && (error || !thresholds))
        return <div>Problem loading thresholds.</div>

    return (
        <>
            <CreditReportActiveUserThresholdingTable
                key={'thresholdingTable'}
                thresholds={thresholds.sort((a, b) => b.MaxActiveCreditUsers - a.MaxActiveCreditUsers)}
                setSelectedThresholdId={setSelectedThresholdId}
                selectedThresholdId={selectedThresholdId}
                createOnClick={() => history.push(`${url}/create`)}
                //deleteOnClick={() => toggleDeleteModal()}
                editOnClick={(id) => history.push(`${url}/${id}/edit`)}
                refetch={refetch}
                loading={loading}

            ></CreditReportActiveUserThresholdingTable>
        </>
    );
}

export default CreditReportActiveUserThresholdingList;